import { render } from "./MetadataRecord.vue?vue&type=template&id=cdcd68c2&scoped=true&ts=true"
import script from "./MetadataRecord.vue?vue&type=script&lang=ts"
export * from "./MetadataRecord.vue?vue&type=script&lang=ts"

import "./MetadataRecord.vue?vue&type=style&index=0&id=cdcd68c2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdcd68c2"]])

export default __exports__